import isEmpty from "is-empty";
import { banksAccountBanexcoin } from "../../../constants";

export const getCurrencyByBankAccount = bankAccount => {
    const findAccount = banksAccountBanexcoin.find(
      b => b.bankAccount === bankAccount
    );
    return !isEmpty(findAccount) ? findAccount.currency : '-';
  };